/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementConflictRequest} from '../models/EntitlementConflictRequest';
import type {EntitlementConflictResponse} from '../models/EntitlementConflictResponse';
import type {Error} from '../models/Error';
import type {RelationPage} from '../models/RelationPage';
import type {ResourceType} from '../models/ResourceType';
import type {SortDirection} from '../models/SortDirection';

export interface GetUserEntitlementRelations$Request {
    userId: number;
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    resourceType?: ResourceType;
    requestBody?: Array<string>;
}

export interface GetUserEntitlementRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserEntitlementRelationsRequest = createAction<PayloadData<void, GetUserEntitlementRelations$Request>>('USER_ENTITLEMENTS__GET_USER_ENTITLEMENT_RELATIONS__REQUEST');
export const getUserEntitlementRelationsSuccess = createAction<PayloadData<RelationPage, GetUserEntitlementRelations$Request>>('USER_ENTITLEMENTS__GET_USER_ENTITLEMENT_RELATIONS__SUCCESS');
export const getUserEntitlementRelationsFailure = createAction<PayloadData<Error, GetUserEntitlementRelations$Request, true>>('USER_ENTITLEMENTS__GET_USER_ENTITLEMENT_RELATIONS__FAILURE');

export const getUserEntitlementRelationsActions = [
    getUserEntitlementRelationsRequest,
    getUserEntitlementRelationsSuccess,
    getUserEntitlementRelationsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {ResourceType} [meta.resourceType] Return only entitlements for resources of this type.
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserEntitlementRelations = (meta: GetUserEntitlementRelations$Request, config?: GetUserEntitlementRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
        resourceType: meta.resourceType,
    };
    return {
        CALL_API: {
            types: getUserEntitlementRelationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/user/${meta.userId}/entitlements`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UserEntitlementConflictChecker$Request {
    userId: number;
    entitlementConflictRequest?: EntitlementConflictRequest;
}

export interface UserEntitlementConflictChecker$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userEntitlementConflictCheckerRequest = createAction<PayloadData<void, UserEntitlementConflictChecker$Request>>('USER_ENTITLEMENTS__USER_ENTITLEMENT_CONFLICT_CHECKER__REQUEST');
export const userEntitlementConflictCheckerSuccess = createAction<PayloadData<Array<EntitlementConflictResponse>, UserEntitlementConflictChecker$Request>>('USER_ENTITLEMENTS__USER_ENTITLEMENT_CONFLICT_CHECKER__SUCCESS');
export const userEntitlementConflictCheckerFailure = createAction<PayloadData<Error, UserEntitlementConflictChecker$Request, true>>('USER_ENTITLEMENTS__USER_ENTITLEMENT_CONFLICT_CHECKER__FAILURE');

export const userEntitlementConflictCheckerActions = [
    userEntitlementConflictCheckerRequest,
    userEntitlementConflictCheckerSuccess,
    userEntitlementConflictCheckerFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {EntitlementConflictRequest} [meta.entitlementConflictRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userEntitlementConflictChecker = (meta: UserEntitlementConflictChecker$Request, config?: UserEntitlementConflictChecker$Config) => {
    return {
        CALL_API: {
            types: userEntitlementConflictCheckerActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/user/${meta.userId}/entitlements-conflicts`,
            TRANSPORT_REQUEST_BODY: meta.entitlementConflictRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

